module.exports = __webpack_public_path__ + "img/gonetwork2_icon16.72467a79.png";